import { ROUTE_PATH, OperationType } from 'common/constants/sm-constants';
import { WidgetModel } from 'common/models/utility-models/base-model';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import {
  GridMetaModel,
  Headers,
} from 'common/models/utility-models/meta-model';

export class AssignmentGridMetaModel extends GridMetaModel<Headers> {
  constructor() {
    super(
      'Assignments',
      ROUTE_PATH.assignmentGrid,
      ROUTE_PATH.assignmentForm,
      true,
      false,
      8,
      true,
      true,
      ['topic', 'type', 'location', 'batch', 'status'],
      false,
      [],
      {
        isDownloadExcel: true,
        excelFileName:
          'AssignmentsA' + new Date().toLocaleDateString() + '.xlsx',
        btnLabel: 'Download Assignmnent List',
        headers: [
          { key: 'Assignment Topic', value: 'topic' },
          { key: 'Type', value: 'type_name' },
          { key: 'Location', value: 'city_name' },
          { key: 'Trainer Name', value: 'trainer_name' },
          { key: 'Trainer Email', value: 'trainer_email' },
          { key: 'Trainer Mobile No.', value: 'trainer_mobile_no' },
          { key: 'Assignment Email', value: 'assignment_email' },
          { key: 'Category Name', value: 'category_name' },
          { key: 'Timeslots', value: 'date_range' },
          { key: 'Invited Student Count', value: 'invited' },
          { key: 'Accepted Student Count', value: 'accepted_student' },
          { key: 'Non Accepted Student Count', value: 'non_accepted_student' },
          { key: 'Attended Student Count', value: 'attended' },
          { key: 'Non Attended Student Count', value: 'non_attended' },
          { key: 'travelDocUploaded_studentCount', value: 'travelDocUploaded_studentCount' },
          { key: 'travelDocnotUploaded_studentCount', value: 'travelDocnotUploaded_studentCount' },
        ],
      },
      false,
      null,
      false,
      false,
      false,
      '',
      { evalKey: 'wantToDelete', evalParam: [0], decisiveParam: true },
      false,
      '',
      null,
      null,
      false,
      true,
      true,
      [],
      false,
      {
        isExtraActions: false,
        btnLabel: '',
        selectOptions: [],
        selectedValue: '',
        isPreviewBtn: false,
        previewBtnLabel: '',
      },
      {
        isCheckboxEmit: false,
        emitKey: 'id',
        checkedKey: '',
        valueKey: '',
      },
      {
        isDownload: false,
        key: '',
        valueKey: '',
      },
      {
        isTabStatus: false,
        label: '',
        isChecked: false,
      },
      false,
      true,
      {
        isPrimary: true,
        isDanger: false,
      },
      '',
      { value: '', isVisible: false },
      false,
      false,
      false
    );
  }

  prepareHeaderList(): Headers[] {
    const headers: Headers[] = [];
    const topic = new Headers('Topic', 'topic', false, true, 'text', '0', {
      isColumnNavigation: true,
      navigationUrl: ROUTE_PATH.assignmentEditForm,
      navigateOperationType: OperationType.UPDATE,
      navigateTransferData: new WidgetModel(),
      navigatePageName: 'View Assignment',
    });
    const type = new Headers('Type', 'type_name', false, true, 'text');
    const location = new Headers('Location', 'city_name', false, true, 'text');
    const dueDate = new Headers(
      'Due Date',
      'date_range',
      false,
      true,
      'text',
      '0',
      {
        isColumnNavigation: true,
        navigationUrl: ROUTE_PATH.assignment_accepted,
        navigateOperationType: OperationType.VIEW,
        navigateTransferData: new GridParams(),
        // navigatePageName: 'Assignment Accepted',
      }
    );
    const invited = new Headers(
      'Invited',
      'invited',
      false,
      true,
      'text',
      '0',
      {
        isColumnNavigation: true,
        navigationUrl: ROUTE_PATH.assignment_accepted,
        navigateOperationType: OperationType.VIEW,
        navigateTransferData: new GridParams(),
        navigatePageName: 'Invited',
      }
    );
    const accepted = new Headers(
      'Accepted',
      'acceptedAssignments',
      false,
      true,
      'text',
      '0',
      {
        isColumnNavigation: true,
        navigationUrl: ROUTE_PATH.assignment_accepted,
        navigateOperationType: OperationType.VIEW,
        navigateTransferData: new GridParams(),
        navigatePageName: 'Assignment Accepted',
      }
    );

    const notAccepted = new Headers(
      'Not Accepted',
      'non_accepted_student',
      false,
      true,
      'text',
      '0',
      {
        isColumnNavigation: true,
        navigationUrl: ROUTE_PATH.assignment_not_accepted,
        navigateOperationType: OperationType.VIEW,
        navigateTransferData: new GridParams(),
      }
    );
    const attended_student = new Headers(
      'Attended',
      'attended',
      false,
      true,
      'text',
      '0',
      {
        isColumnNavigation: true,
        navigationUrl: ROUTE_PATH.adminTravelDetail,
        navigateOperationType: OperationType.VIEW,
        navigateTransferData: this.getGridParams('1'),
        navigatePageName: 'Attended',
      }
    );
    const notattended_student = new Headers(
      'Not Attended',
      'non_attended',
      false,
      true,
      'text',
      '0',
      {
        isColumnNavigation: true,
        navigationUrl: ROUTE_PATH.adminTravelDetail,
        navigateOperationType: OperationType.VIEW,
        navigateTransferData: this.getGridParams('2'),
        navigatePageName: 'Not Attended',
      }
    );
    const trainer = new Headers('', 'trainerView', false, true, 'button', '0', {
      isColumnNavigation: true,
      navigationUrl: ROUTE_PATH.trainersView,
      navigateOperationType: OperationType.VIEW,
      navigateTransferData: new GridParams(),
    });
    const travel = new Headers(
      '',
      'travel',
      false,
      true,
      'button',
      '0',
      {
        isColumnNavigation: true,
        navigationUrl: ROUTE_PATH.admintravelReimbursement,
        navigateOperationType: OperationType.VIEW,
        navigateTransferData: new GridParams(),
      },
      ['', ''],
      {
        isToggle: false,
        toggleKey: '',
        toggleCheckedValue: '',
        toggleUncheckedValue: '',
      }
    );
    headers.push(topic);
    headers.push(type);
    headers.push(location);
    headers.push(dueDate);
    headers.push(invited);
    // headers.push(accepted);
    // headers.push(notAccepted);
    headers.push(attended_student);
    headers.push(notattended_student);
    headers.push(trainer);
    headers.push(travel);
    return headers;
  }

  getGridParams(value) {
    const params = new GridParams();
    params.transferData = value;
    return params;
  }
}
